import { render, staticRenderFns } from "./EditSchoolData.vue?vue&type=template&id=4dbcb262&scoped=true&"
import script from "./EditSchoolData.vue?vue&type=script&lang=js&"
export * from "./EditSchoolData.vue?vue&type=script&lang=js&"
import style0 from "./EditSchoolData.vue?vue&type=style&index=0&id=4dbcb262&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbcb262",
  null
  
)

export default component.exports